import { render } from "./UiModalPageHeader.vue?vue&type=template&id=0941fd7f"
const script = {}

import "./UiModalPageHeader.vue?vue&type=style&index=0&id=0941fd7f&lang=css"

import exportComponent from "/home/dima/Work/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__